import React from 'react';
import optc from '../optc.json'
import { useTranslation } from "react-i18next";

const Licences = () => {

  const [t] = useTranslation('common');

  return (


    <div id="overflow-table">
      
      <div className="row justify-content-center">

        <div className="col-lg-9 col-11">

          <h1 className="display-4 text-center">{t('license.license')}</h1>
          <table className="table">
            <thead>
              <tr>
                <th className="text-center">{t('license.organization')}</th>
                <th className="text-center">{t('license.region')}</th>
                <th >{t('license.license')}</th>
              </tr>
            </thead>
            <tbody> {/*Unique values of operators only*/}
              {[...new Map(optc.optc.map(item =>
                [item.nom, item])).values()].map((e) => (
                  <tr key={e.operateur}>
                    <td>{e.nom}</td>
                    <td>{e.region}</td>
                    <td className="align-middle text-start"><a href={e.licence}>{e.licence}</a></td>
                  </tr>
                )
                )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default Licences;
